import { useParams } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import { ProfileContext } from "../contexts/profileContext";
import { PageWrapper } from "../components/admin";
import { OrgProfessions } from "../components/admin/organization";
import { FaEdit } from "react-icons/fa";
import { ArrowBackIcon } from "../asssets/icons";

export default function Professions() {
  const [profile] = useContext(ProfileContext);
  const [org, setOrg] = useState(null);
  const [currentUI, setCurrentUI] = useState("professions");

  const { orgId } = useParams();
  const { organizations } = profile;

  useEffect(() => {
    if (!orgId || !organizations?.length) return;
    const org = organizations.find((org) => org._id === orgId);
    if (!org) return;

    setOrg({ ...org });
  }, [orgId, organizations]);

  const handleUIResetClick = () => {
    setCurrentUI(null);
  };

  if (!org?._id) return <div>Loading...</div>;

  return (
    <div className="h-screen overflow-y-auto pb-20">
      {!currentUI && (
        <PageWrapper pageHeading={"Organisation Professions"}>
          <div className="flex flex-row justify-between items-center">
            <div className="w-full bg-[#ffffff] rounded relative">
              <div className="flex justify-start items-center gap-4 px-4 py-3 cursor-pointer shadow-sm">
                Professions
              </div>
            </div>
            <div className="cursor-pointer" onClick={() => setCurrentUI("professions")}>
              <FaEdit />
            </div>
          </div>
        </PageWrapper>
      )}
      {currentUI === "professions" && (
        <>
          <button
            className="flex gap-3 items-center w-[fit-content] flex-wrap mb-10"
            onClick={handleUIResetClick}>
            <span className="w-8 h-8">
              <ArrowBackIcon />
            </span>
            <h2 className="text-xl leading-10 font-bold">Professions</h2>
          </button>
          <OrgProfessions org={org}></OrgProfessions>
        </>
      )}
    </div>
  );
}
